/**
 * Moduł do obsługi zdjęć produktu.
 * Obsługa zdarzeń: kliknęć, hoverow, wyswietlenia modala z karuzelą zdjęć
 * @type module
 */
app.service("productCardPhotos", function(productCardConfig, productMultimedia, _) {
	let config;
	var $self,$previousPhoto,$nextPhoto,$carousel, $bigPhoto;
	var miniaturesLength;
	var firstVisible, lastVisible, currentShift;

	function setElements(){
		$self = config.productCardTestEnabled ? $('#product-top .product-photos') : $('#product-card .product-photos');
		$previousPhoto = $self.find('#miniatures-previous');
		$nextPhoto = $self.find('#miniatures-next');
		$carousel = $self.find('.js-miniatures-carousel');
		miniaturesLength = $self.find('#miniatures-list li').length;
		$bigPhoto = $self.find('#big-photo');
		firstVisible = 1;
		currentShift = 0;

		if(config.productCardTestEnabled) {
			setLastVisibleCount();
		} else {
			lastVisible = $carousel.data('visible');
		}
	}
	function setEvents(){
		$bigPhoto.click(function(e){
			e.preventDefault();
			bigPhotoClick($(this).data('type'),$(this).data('index'));
		});
		$('#product-image-sales').click(function(){
			$bigPhoto.trigger('click');
		});
		$previousPhoto.click(function(){
			previousPhoto();
		});
		$nextPhoto.click(function(){
			nextPhoto();
		});
		$carousel.swipe({
			swipe: function(event, direction, distance, duration, fingerCount, fingerData) {
				if(direction == 'left' && !($nextPhoto.hasClass('disabled'))) {
					nextPhoto();
				} else if (direction == 'right' && !($previousPhoto.hasClass('disabled'))){
					previousPhoto();
				}
			},
			excludedElements: "label, button, input, select, textarea, .noSwipe",
			allowPageScroll: "auto"
		});
		$('.js-miniatures-photo a').hover(function(){
			hover($(this).data('index'));
		});
		$('.js-miniatures-carousel a').click(function(){
			showMultimedia($(this).data('type'),$(this).data('index')/1);
			return false;
		});
		if(config.productCardTestEnabled) {
			$(window).resize(_.debounce(setLastVisibleCount, 250));
		}

		/* Swipe do zrobienia z pluginem
		 * Dokończyć warunki w nextPhoto, prevPhoto dla no-carousel
		$('#big-photo').on('swipeleft', function() {
			nextPhoto();
		}).on('swiperight', function() {
			prevPhoto();
		});
		*/
	}
	function setLastVisibleCount() {
		lastVisible = window.innerWidth >= 1231 ? 6 : 5;
		if(miniaturesLength <= lastVisible) {
			$self.find('#miniatures').addClass('no-carousel');
		}
	}
	function bigPhotoClick(elementType,elementIndex) {
		if(!$('#watched-list').length){
			showMultimedia(elementType,elementIndex/1);
			return false;
		}
	}
	function nextPhoto() {
		if( $('#miniatures').hasClass('no-carousel') ) {
			$('.miniatures-photo-active').next().trigger('mouseenter');
		}
		else {
			$previousPhoto.removeClass('disabled');
			$carousel.addClass('shift-' + (currentShift+1));
			$carousel.removeClass('shift-' + currentShift);
			firstVisible++;
			lastVisible++;
			currentShift++;

			if(lastVisible === miniaturesLength){
				$nextPhoto.addClass('disabled');
			}
		}
	}
	function previousPhoto() {
		if( $('#miniatures').hasClass('no-carousel') ) {
			$('.miniatures-photo-active').prev().trigger('mouseenter');
		}
		else {
			$nextPhoto.removeClass('disabled');
			$carousel.addClass('shift-' + (currentShift-1));
			$carousel.removeClass('shift-' + currentShift);
			firstVisible--;
			lastVisible--;
			currentShift--;
			if(firstVisible === 1){
				$previousPhoto.addClass('disabled');
			}
		}
	}
	function hover(index) {
		$self.find('.miniatures-photo-active').removeClass('miniatures-photo-active');
		var activeElement = $('.js-miniatures-photo:eq('+index+')').addClass('miniatures-photo-active');
		var img = activeElement.find('a').data('img');
		var alt = activeElement.find('a img').attr('alt');
		$bigPhoto.data('index', index);
		$bigPhoto.attr('href', img);
		$bigPhoto.find('img').remove();
		$('<img src="' + img + '" alt="' + alt + '" />').appendTo('#big-photo');
	}

	function showMultimedia(elementType,elementIndex){
		productMultimedia.show({
			type : elementType || false,
			index : elementIndex || 0,
			productId : productCardConfig.getData().id || undefined
		 });
	}
	function init() {
		config = $.extend({}, productCardConfig.getData());
		setElements();
		setEvents();
	}
	return {
		init : init
	};
});
